module.exports = __webpack_public_path__ + "img/load_year_emi.7be44cff.svg";